import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-card-success-popup',
  standalone: false,
  templateUrl: './card-success-popup.html',
  styleUrl: './card-success-popup.scss'
})
export class CardSuccessPopup {
  constructor(
    private readonly dialogRef: MatDialogRef<CardSuccessPopup>,
    @Inject(MAT_DIALOG_DATA) public data: { message: string }
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}
